exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-button[data-v-39f62e4e]{width:80px;background-color:#163247!important;border-color:#042035!important;float:right}.form-button[data-v-39f62e4e]:hover{background-color:#042035!important;border-color:#042035!important;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-39f62e4e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/FormButton.vue
// module id = 890
// module chunks = 0